<template>
    <div class="ratings-enter">
        <div v-for="(rating, index) in ratings" :key="rating.key" class="rating">
            <div v-show="isRatingDisplayed(index)">
                <h5 v-if="rating.text" class="text-emphasized">
                    {{ rating.text }}
                </h5>

                <rating-enter :rating="rating" @rated="rated"></rating-enter>
            </div>
        </div>

        <div class="ratings-enter__dots">
            <span v-for="i in ratings.length" :key="i" class="ratings-enter__dot">
                <svg><use :xlink:href="dotIconName(i)" /></svg>
            </span>
        </div>

        <!-- <div class="buttons"> -->
        <common-buttons>
            <common-button
                v-show="allowBackButton && !areRatingsEntered"
                :isDisabled="!hasPreviousGrades && !areRatingsEntered"
                :label="$t('pages.referrals.update.ratings_enter.buttons.back')"
                type="secondary"
                size="large"
                @click="back"
            ></common-button>

            <common-button
                v-show="!isLast || !areAllRated"
                :label="$t('pages.referrals.update.ratings_enter.buttons.next')"
                :isDisabled="!isCurrentGraded || isLast"
                type="primary"
                size="large"
                @click="next"
            ></common-button>

            <common-button
                v-if="areAllRated && isLast"
                :label="$t('pages.referrals.update.ratings_enter.buttons.done')"
                type="primary"
                size="large"
                @click="ratingsEntered"
            ></common-button>
        </common-buttons>
        <!-- </div> -->
    </div>
</template>

<script>
    import RatingEnter from './RatingEnter'

    export default {
        components: {
            RatingEnter,
        },
        props: {
            ratings: {
                type: Array,
                required: true,
            },
            allowBackButton: { type: Boolean, default: false },
        },
        data() {
            return {
                grades: this.ratings.reduce((grades, rating) => {
                    grades[rating.key] = null
                    return grades
                }, {}),
                currentIndex: 0,
                areRatingsEntered: false,
            }
        },
        computed: {
            hasPreviousGrades() {
                return this.currentIndex > 0
            },
            isCurrentGraded() {
                let currentRating = this.ratings[this.currentIndex]
                return currentRating && this.grades[currentRating.key] > 0
            },
            isLast() {
                return this.currentIndex == this.ratings.length - 1
            },
            areAllRated() {
                return Object.keys(this.grades).every((key) => this.grades[key] != null)
            },
        },
        methods: {
            rated(rating) {
                this.grades[rating.key] = rating.grade
            },
            next() {
                this.currentIndex = this.currentIndex + 1
            },
            back() {
                this.currentIndex = this.currentIndex - 1
            },
            ratingsEntered() {
                this.currentIndex = null
                this.areRatingsEntered = true
                this.$emit('ratings-entered', this.grades)
            },
            isRatingDisplayed(star) {
                return star == this.currentIndex
            },
            dotIconName(step) {
                return step == this.currentIndex + 1 ? '#icon-dot-on' : '#icon-dot-off'
            },
            classForText(rating) {
                return rating.question ? 'text-regular' : 'text-emphasized'
            },
        },

        watch: {
            ratings() {
                this.grades = this.ratings.reduce((grades, rating) => {
                    grades[rating.key] = null
                    return grades
                }, {})
            },

            currentIndex() {
                if (this.currentIndex !== 0) {
                    this.$emit('first-rating-entered')
                }
            },
        },
    }
</script>

<style scoped>
    .ratings-enter {
        margin: auto;
        padding-bottom: 10px;
    }
    .text-emphasized {
        font-size: 24px;
        margin: 1.5rem 0 2rem 0;
        font-weight: 600;
        color: #333333;
    }

    .text-regular {
        font-size: 18px;
        color: #666666;
        word-spacing: 0.01em;
        padding-bottom: 30px;
    }

    .dot {
        display: inline-block;
        height: 16px;
        width: 16px;
        margin: 0 5px;
    }
</style>
